if (!customElements.get('gk-feature-video')) {
  customElements.define('gk-feature-video', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const button = this.querySelector('button');
      button?.addEventListener('click', () => {
        const content = this.querySelector('template');
        if (!content || this.querySelector('video, iframe')) return;
        this.append(content.content.cloneNode(true));
        button.hidden = true;
        const player = this.querySelector('video, iframe');
        player?.focus();
        if (player instanceof HTMLVideoElement) player.play().catch(() => {});
      });
    }
  });
}
